import { render } from "./AttributeUnitPicker.vue?vue&type=template&id=2b43c3cf&scoped=true"
import script from "./AttributeUnitPicker.vue?vue&type=script&lang=js"
export * from "./AttributeUnitPicker.vue?vue&type=script&lang=js"

import "./AttributeUnitPicker.vue?vue&type=style&index=0&id=2b43c3cf&scoped=true&lang=css"
import "./AttributeUnitPicker.vue?vue&type=style&index=1&id=2b43c3cf&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b43c3cf"]])

export default __exports__